
import { BookingStateEnum } from '@xeetr/types/enums'
import { Settings } from '@xeetr/types/models'
import { Controller, useFormContext } from 'react-hook-form'

import FloatingLabel from '../../../inputs/FloatingLabel'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'


const ServiceTenantReservation = () => {
  const { control } = useFormContext<Settings>()

  const items = [
    { state: 'Offen', value: BookingStateEnum.OPEN },
    { state: 'Bestätigt', value: BookingStateEnum.ACCEPTED },
    { state: 'Eingecheckt', value: BookingStateEnum.CHECKEDIN },
  ]

  return (
    <Controller
      name="tenant.settings.defaultStateBookings"
      control={control}
      render={({ field }) => (
        <FloatingLabel label="Status für neue Reservierungen" className="md:col-span-3">
          <Select defaultValue={field.value} onValueChange={field.onChange}>
            <SelectTrigger className="md:w-48">
              <SelectValue placeholder="Option auswählen" />
            </SelectTrigger>
            <SelectContent>
              {items.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.state}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </FloatingLabel>
      )}
    />
  )
}

export default ServiceTenantReservation
